
export default {
  methods: {
    $log (action, model = 'No model', model_id = null) {
      this.$store.dispatch('log', { action, model, model_id })
    },
    $logFrance (code, text = '(null)') {
      // from XEF's APP FiscalCountryFrance @ customLog
      const userId = this.$store.state.user.id ?? '(null)'
      this.$log(`FR:${code}:${userId}:${text}`)
    },
  }
}
